import { defineMessages } from 'react-intl'

const scope = `procurify.components.VendorPaymentMethodSelect`

export default defineMessages({
  selectFieldPlaceholder: {
    id: `${scope}.selectFieldPlaceholder`,
    defaultMessage: 'Select a vendor payment method',
  },
  createPaymentMethodLabel: {
    id: `${scope}.createPaymentMethodLabel`,
    defaultMessage: 'Add new',
  },
})
